import { PublicClientApplication, type Configuration, LogLevel } from '@azure/msal-browser'
import { config, isEntraConfigured } from '../config'

/**
 * Microsoft Entra ID (MSAL) opsætning.
 *
 * Cachen ligger i localStorage, så et installeret PWA husker loginnet mellem
 * app-starter (kravspec afsnit 46 og 51). Der findes intet separat login til
 * mobil - PC, tablet og mobil bruger samme Microsoft 365-konto og samme roller.
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: config.entra.clientId,
    authority: `https://login.microsoftonline.com/${config.entra.tenantId}`,
    redirectUri: config.entra.redirectUri,
    postLogoutRedirectUri: config.entra.redirectUri,
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Error,
      loggerCallback: (level, message, containsPii) => {
        if (!containsPii && level === LogLevel.Error) {
          console.error('[MSAL]', message)
        }
      }
    }
  }
}

/** Scopes API-et kræver. Falder tilbage til profiladgang hvis API-scope ikke er sat op endnu. */
export const apiRequest = {
  scopes: config.entra.apiScope ? [config.entra.apiScope] : ['User.Read']
}

/** Scope til Microsoft Graph. Bruges kun til at hente brugerens profilbillede. */
export const graphRequest = {
  scopes: ['User.Read']
}

export const loginRequest = {
  scopes: [...apiRequest.scopes, ...graphRequest.scopes, 'openid', 'profile', 'email']
}

export const msalInstance = isEntraConfigured ? new PublicClientApplication(msalConfig) : null
